import { RootStore } from '../../reducers';
import { buildCacheKey } from '../../cache';
import { DictionaryEntry, DictionaryItem, DictionaryName } from './model';
import { getCachedDictionary } from './selectors';

// Читает запись кэша словаря по текущим параметрам запроса и возвращает её вместе с ключом
// (ключ нужен вызывающему, чтобы потом записать в кэш свежий ответ).
//
// entry === undefined — кэша нет, показываем скелетон и грузим как обычно.
// isCacheStale(entry) — запись из прошлой сессии или залежавшаяся: показываем мгновенно и
//   обновляем в фоне. Иначе — показываем и в сеть не идём (см. loadDictionary).
export function readDictionaryCache<N extends DictionaryName>(
  state: RootStore,
  dict: N,
  params: Record<string, unknown>,
): { key: string; entry: DictionaryEntry<DictionaryItem<N>> | undefined } {
  const key = buildCacheKey(params);
  return { key, entry: getCachedDictionary(state, dict, key) };
}
